import { IamProviderType } from '@1po/1po-bff-fe-spec/generated/backoffice/central_settings/model/CentralCountrySettings';

import { APP_NAMESPACE } from 'app/App.constants';

export const CENTRAL_SETTINGS_NAMESPACE = `${APP_NAMESPACE}/CENTRAL_SETTINGS`;

export const GET_CENTRAL_SETTINGS_REQUEST = `${CENTRAL_SETTINGS_NAMESPACE}/GET_CENTRAL_SETTINGS_REQUEST`;
export const UPDATE_CENTRAL_SETTINGS_REQUEST = `${CENTRAL_SETTINGS_NAMESPACE}/UPDATE_CENTRAL_SETTINGS_REQUEST`;
export const ADD_SELLER_REQUEST = `${CENTRAL_SETTINGS_NAMESPACE}/ADD_SELLER_REQUEST`;
export const UPDATE_SELLER_DATA_PROVIDERS_REQUEST = `${CENTRAL_SETTINGS_NAMESPACE}/UPDATE_SELLER_DATA_PROVIDERS_REQUEST`;
export const DELETE_SELLER_REQUEST = `${CENTRAL_SETTINGS_NAMESPACE}/DELETE_SELLER_REQUEST`;

export const DEFAULT_COUNTRY = 'FR';
export const DEFAULT_IAM_PROVIDER = 'MOTRIO' as IamProviderType;
